<template>
    <div>

        <!-- Hack to check custom rows conditions -->
        <div class="d-none">
            <form-row 
            v-for="row in rows"
            :key="'row-'+row.id" 
            :row="row" /> 
        </div>

        <transition-group name="slide-fade">
            <div 
            key="empty"
            class="text-center"
            v-if="!id">
                Une key est nécéssaire pour afficher le formulaire.
            </div>

            <div 
            key="loader"
            class="text-center"
            v-if="id && loading">
                <loader />
            </div>

            <component 
            key="form"
            v-else-if="id && !loading"
            :is="layoutFile" />

        </transition-group>

        <slot></slot>
        
    </div>
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        props: {
            id: {
                type: String,
                default: '',
            }
        },

        data() {
            
            return {
                loading: false,
                test: []
            }
        },

        computed: {

            ...mapState({
                form: state => state.form.form,
                sections: state => state.form.sections,
                rows: state => state.form.rows,
                stop: state => state.form.stop,
                validations: state => state.form.customFieldsValidations
            }),

            ...mapGetters('form', [
                'answers',
                'progress'
            ]),
            
            layoutFile() {

                var tpl = 'default/Layout'
                var custom = false
                var layouts = require.context('@components/forms/layouts', true);
                var key = this.form.theme ? this.form.theme : this.form.key

                layouts.keys().forEach(file => {
                    if(file.includes(this.form.layout))
                    {
                        tpl = this.form.layout+'/Layout'
                    }
                })

                // Is there a custom layout ?
                try {
                    let file = require('@components/forms/'+key+'/Layout');
                    custom = true
                } catch (e) {}

                if(tpl) {
                    return () => custom 
                    ? import(`@components/forms/${key}/Layout.vue`)
                    : import(`@components/forms/layouts/${tpl}.vue`);
                }

            }

        },

        mounted() {

            this.loading = true

            var lang = document.documentElement.getAttribute('lang')

            this.$store.commit('lang/setLang', lang)
            window.i18n.locale = lang

            if(this.id)
            {
                this.$store
                .dispatch('form/initForm', this.id)
                .then(() => { 
                    this.loading = false 
                })
            }

            

        }
        
    }
</script>